import React from 'react';
import {Box, Stack, Typography} from "@mui/material";
import SteepItemCircleSingleVoyage
    from "@containers/singleVoyage/views/stepperLine/steepItem/SteepItemCircleSingleVoyage";
import {sx} from './sx'
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {
    MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY
} from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/constants";
import MoveIcon from "@resource/svg/MoveIcon";
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";

interface IProps {
    point: IWayPointCreationSingleVoyage,
    index: number
}

const ReorderPointItemMutateSingleVoyage = ({point, index}: IProps) => {

  const name = point?.name?.length > 30 ? `${point.name?.slice(0,30)}..` : point.name;
    return (
        <Box
            sx={sx.cardWrapper}
        >
            <Stack
                sx={sx.card}
            >
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                >
                    <SteepItemCircleSingleVoyage
                        number={index + 1}
                        showLine={false}
                        sx={sx.circle}
                    />

                    <IconButtonCustom
                        variant={'empty'}
                        className={MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY}
                    >
                        <MoveIcon/>
                    </IconButtonCustom>
                </Stack>

                <Typography
                    sx={sx.name}
                    variant={'body2'}
                >
                    {name}
                </Typography>

            </Stack>
        </Box>
    );
};

export default ReorderPointItemMutateSingleVoyage;